import LinearProgress from '@mui/material/LinearProgress'
import Stack from '@mui/material/Stack'

import styles from './styles.module.scss'

interface LoadingScreenProps {
  backgroundColor?: string
  text?: string
}

export const LoadingScreen = ({
  backgroundColor,
  text,
}: LoadingScreenProps) => {
  return (
    <div
      className={styles.loadingScreen}
      style={{ backgroundColor: backgroundColor || '#0000009f' }}
    >
      <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress color="primary" />
      </Stack>
      <div className={styles.messageLoading}>{text && <p>{text}</p>}</div>
    </div>
  )
}
